import axios, { AxiosTransformer } from 'axios';

import { connection } from './globals/internet';
import { versionMarketing } from './globals/status';

import { v4 as uuidv4 } from 'uuid';
import { i18n } from './i18n/i18n';


export function getApiEndpoint() {
    return localStorage.apiEndpoint || import.meta.env.VITE_APP_BASE_URL;
}

const zsAxios = axios.create({
    baseURL: getApiEndpoint(),
    timeout: 10000,
    transformRequest: [function (data, headers) {
        let authType = "Bearer";
        if (localStorage.accessMode == 'Device') authType = "DeviceV2";

        if (localStorage.deviceConfig) {
            const atlasCredentials = JSON.parse(localStorage.deviceConfig);
            const accessToken = "id=" + atlasCredentials.id + " salt=" + atlasCredentials.salt;
            headers.Authorization = authType + " " + accessToken;
        } else if (localStorage.accessToken && !headers.Authorization) {
            headers.Authorization = authType + " " + localStorage.accessToken;
        }

        headers['X-Request-Id'] = uuidv4();
        headers['X-Device-Version'] = versionMarketing;
        headers['X-Language'] = i18n.global.locale;

        return data;
    }, ...(axios.defaults.transformRequest as AxiosTransformer[])],
});


zsAxios.interceptors.response.use(response => response, function (error: any) {
    if (error.message == "Network Error") {
        if (connection.isConnected.value) {
            connection.disable();
        }
        return;
    }

    if (error.response && error.response.status == 403 && localStorage.accessToken) {
        delete localStorage.accessToken;
        const router = (window as any).router;
        if (router) router.push("/authentication/login/");
    }
    // console.log(error.response);
    // TODO
    // if (error.response && error.response.status == 401) {
    //     router.push('/authentication/login/');
    //     return;
    // }
    throw error;
})

export default zsAxios;
